<template>
  <div class="siesta-instruction horizontal center" v-bind:style="{maxWidth: maxWidth}">
    <img class="icon" :src="icon" alt />
    <p class="text2 msg" v-html="msg"></p>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    maxWidth: String,
    msg: String
  }
};
</script>

<style lang="scss" scoped>
.siesta-instruction {
  flex: 1;
}
.tiny .siesta-instruction,
.mobile .siesta-instruction {
  flex: 0;
}
.msg {
  text-align: left;
  white-space: nowrap;
}
.text2 {
  font-size: rems(16px);
}
.icon {
  margin-right: rems(22px);
  width: rems(46px);
  height: rems(43px);
}
.tiny .icon {
  margin-right: rems(0px);
  margin-bottom: rems(12px);
}
.tiny .msg {
  text-align: center;
}
.tiny .msg {
  font-size: rems(18px);
}
.tiny .siesta-instruction {
  flex-direction: column;
}
</style>
